<template>
  <div class="md:flex" :class="{'flex-col': vertical}">
    <lm-input
      ref="inputBeginDate"
      label="Init date"
      type="date"
      :class="{'md:mr-8': !vertical}"
      :maxlength="0"
      :optional="true"
      @submit="$emit('submit')"
      @change="$emit('change')"
    />
    <lm-input
      ref="inputEndDate"
      label="End date"
      type="date"
      class=""
      :maxlength="0"
      :optional="true"
      @submit="$emit('submit')"
      @change="$emit('change')"
    />
  </div>
</template>
<script>
import format from 'date-fns/format'
import LmInput from '@/components/form/LmInput.vue'

export default {
  name: 'LmDateBeginEndInput',
  components: {
    LmInput
  },
  props: {
    vertical: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      error: false,
      errorEmpty: 'Please choose a date',
      errorConsistency: 'Init Date must be before End Date'
    }
  },
  methods: {
    getData() {
      return {
        beginDate: this.$refs.inputBeginDate.data,
        endDate: this.$refs.inputEndDate.data
      }
    },
    setData(beginAt, endAt) {
      if (beginAt) {
        this.$refs.inputBeginDate.data = format(beginAt, 'YYYY-MM-DD')
      } else {
        this.$refs.inputBeginDate.data = ''
      }
      if (endAt) {
        this.$refs.inputEndDate.data = format(endAt, 'YYYY-MM-DD')
      } else {
        this.$refs.inputEndDate.data = ''
      }
    },
    clearErrors() {
      this.error = false
      this.$refs.inputBeginDate.clearErrors()
      this.$refs.inputEndDate.clearErrors()
    },
    validateData() {
      this.clearErrors()
      const beginAt = this.$refs.inputBeginDate.data
      const endAt = this.$refs.inputEndDate.data
      if (!beginAt) {
        this.$refs.inputBeginDate.setError(this.errorEmpty)
      }
      if (!endAt) {
        this.$refs.inputEndDate.setError(this.errorEmpty)
      }
      if (!beginAt || !endAt) return false
      if (beginAt && endAt && beginAt > endAt) {
        this.$refs.inputBeginDate.setError(this.errorConsistency)
        this.$refs.inputEndDate.setError(this.errorConsistency)
        return false
      }
      return true
    }
  }
}
</script>
